module.exports = __webpack_public_path__ + "rili.daaac28b.jpg";